export default __webpack_public_path__ + "locales/ar-SA/Errors.json?hash=c5ea134d6958b30401d0c40f74bfe416";